import CheckIcon from '@mui/icons-material/Check';
import { Box, Grid, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import {
    Timeline,
    TimelineContent,
    TimelineDot,
    TimelineItem,
    TimelineSeparator,
    timelineItemClasses,
} from '@mui/lab';
import { useAppSelector } from '../../store/hooks';
import NavLinkButton from '../Navigation/NavLinkButton/NavLinkButton';
import { StayInContactIcon } from '../Shared/StayInContactIcon';
import { DialerTimelineItem } from './DialerTimelineItem';
import { DownloadAppsTimelineItem } from './DownloadAppsTimelineItem';
import { UserDetailsTimelineItem } from './UserDetailsTimelineItem';
import { UserEmailTimelineItem } from './UserEmailTimelineItem';

export function GettingStarted() {
    const { classes } = useStyles();

    const dialerIsEnabled = useAppSelector(state => state.user.dialerIsEnabled);
    const dialerIsSetup = useAppSelector(state => state.user.dialerIsSetup);
    const dialerPhone = useAppSelector(state => state.user.dialerPhone);
    const userEmailId = useAppSelector(state => state.user.userEmailId);
    const userName = useAppSelector(state => state.user.userName);
    const firstName = useAppSelector(state => state.user.userFirstName);
    const lastName = useAppSelector(state => state.user.userLastName);
    const userPhone = useAppSelector(state => state.user.userPhone);
    const userEmail = useAppSelector(state => state.user.userEmail);

    const userDetailsComplete = !!firstName && !!lastName && !!userPhone && !!userEmail;
    const dialerComplete = (dialerIsEnabled && dialerIsSetup) || !dialerIsEnabled;
    const emailComplete = !!userEmailId;

    const setupComplete = userDetailsComplete && dialerComplete && emailComplete;

    return (
        <div className={classes.root}>
            <Grid
                container
                flexDirection="column"
                alignItems="center"
                wrap="nowrap"
                spacing={6}
                p={6}
                sx={{ maxWidth: '1200px' }}
            >
                <Grid item>
                    <Box className={classes.iconWrapper}>
                        <StayInContactIcon className={classes.icon} />
                    </Box>
                </Grid>
                <Grid item>
                    <Typography variant="h3" textAlign="center">
                        Welcome to StayInContact, {firstName}!
                    </Typography>
                </Grid>
                <Grid item>
                    <Timeline
                        sx={{
                            [`& .${timelineItemClasses.root}:before`]: {
                                flex: 0,
                                padding: 0,
                            },
                        }}
                    >
                        <UserDetailsTimelineItem
                            userName={userName}
                            userPhone={userPhone}
                            userEmail={userEmail}
                            firstName={firstName}
                            lastName={lastName}
                        />
                        <DialerTimelineItem
                            dialerIsEnabled={dialerIsEnabled}
                            dialerIsSetup={dialerIsSetup}
                            dialerPhone={dialerPhone}
                        />
                        <UserEmailTimelineItem userEmailId={userEmailId} />
                        <DownloadAppsTimelineItem />
                        {/* <AddContactsTimelineItem /> */}
                        <TimelineItem>
                            <TimelineSeparator>
                                <TimelineDot color={setupComplete ? 'success' : undefined}>
                                    <CheckIcon />
                                </TimelineDot>
                            </TimelineSeparator>
                            <TimelineContent>
                                <NavLinkButton pathname="/">Take me to my Dashboard</NavLinkButton>
                                <Typography color={'text.secondary'} fontSize="0.75rem">
                                    Some features will not be available until you complete your
                                    account setup.
                                </Typography>
                            </TimelineContent>
                        </TimelineItem>
                    </Timeline>
                </Grid>
            </Grid>
        </div>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        backgroundColor: theme.palette.backgroundMainLayout.main,
        display: 'flex',
        justifyContent: 'center',
        overflowY: 'auto',
    },
    iconWrapper: {
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        background: 'linear-gradient(180deg, rgba(4,58,107,1) 0%, rgba(0,48,84,1) 100%)',
    },
    icon: {
        width: '100%',
        height: '100%',
    },
}));
